import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { compose } from 'redux';

import Configuration from 'redpoints-connector-common/helper/Configuration';

import {
  withContext,
  withQueryParams,
} from 'redpoints-front-common/components';
import { cast } from 'redpoints-front-common/helpers';

import { facilitatorValidationClear } from '../../../actions/facilitatorValidationActions';
import { getFacilitatorValidationFiltersSelected } from '../../../reducers/tasks/facilitatorValidation';
import FacilitatorValidationContent from './FacilitatorValidationContent';
import FacilitatorValidationFilters from './FacilitatorValidationFilters';
import { castOptions } from '../../../config/facilitatorValidationConfiguration';
import useLoadInitialFacilitatorValidation from './useLoadInitialFacilitatorValidation';

import './facilitatorValidation.less';

const FacilitatorValidation = ({
  customer: { customerId },
  facilitatorValidationClear,
  filtersSelected,
  queryParams,
}) => {
  const castedQueryParams = cast(castOptions)(queryParams);
  const [isEnableFilterByTenant, setIsEnableFilterByTenant] = useState(null);

  useEffect(() => {
    const getConfiguration = async () => {
      try {
        const configuration = await Configuration.getJSONConfig();
        setIsEnableFilterByTenant(
          configuration.task?.enableFilterByTenant ?? false
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };

    getConfiguration();
  }, []);

  useLoadInitialFacilitatorValidation({
    castedQueryParams,
    customerId,
    isEnableFilterByTenant,
  });

  const filtersFromQueryParams = {
    domainId: castedQueryParams.domainId ?? null,
    filterByCustomer: castedQueryParams.filterByCustomer ?? null,
  };

  const hasFiltersApplied = isEqual(filtersFromQueryParams, filtersSelected);

  useEffect(() => {
    return () => {
      facilitatorValidationClear();
    };
  }, [facilitatorValidationClear]);

  return (
    <div className="facilitator-validation-container">
      <FacilitatorValidationFilters
        isEnableFilterByTenant={isEnableFilterByTenant}
      />
      <FacilitatorValidationContent hasFiltersApplied={hasFiltersApplied} />
    </div>
  );
};

const mapStateToProps = state => ({
  filtersSelected: getFacilitatorValidationFiltersSelected(state),
});

export default compose(
  withContext,
  withQueryParams,
  connect(mapStateToProps, {
    facilitatorValidationClear,
  })
)(FacilitatorValidation);
